import { toObjectified } from 'api/baseApi';
import { AsObjectified, Inline } from 'api/utils';
import { Payload, useFetch, usePost, } from 'api/reactQuery/queryService';
import { APIRoutes } from './constants';
import { INotepadDetailResponse, INotepadFacade } from 'api/swaggerTypes';

interface IModule {
    name: string;
    selectedItem: string | number;
    entity: string;
    tableId?: string;
}

export type IObjectifiedNotepadResponse = AsObjectified<INotepadDetailResponse, 'Notepad'>;
const notepadResponseParser = (response: INotepadDetailResponse) => {
    const { Notepad } = response;

    return {
        ...response,
        Notepad: Notepad ? toObjectified(Notepad as Inline<INotepadFacade>) : null
    };
};

export const useRetrieveNotepadDetail = (module: IModule) =>
    useFetch<IObjectifiedNotepadResponse>(
        {
            url: APIRoutes[module?.name].notepad.retrieve,
            queryConfig: { enabled: !!module?.selectedItem },
            urlParams: { [module?.entity]: module?.selectedItem },
            options: { inline: true, responseParser: notepadResponseParser }
        }
    );

export const useCreateNotepadDetail = (module: IModule) =>
    usePost<Payload<any>, any>
        (APIRoutes[module?.name].notepad.update, null, { inline: true, });
